import FrameworkContract from '@spraypaint/FrameworkContract';
import { findQueryBuilder } from '@/app/utils/findQueryBuilder';

const findQuery = findQueryBuilder(FrameworkContract);
export const buildFrameworkContractFindQuery = findQuery.buildQuery;
export const buildFrameworkContractFindQueryLoader = findQuery.buildLoader;
export const useFrameworkContractFindQuery = findQuery.useFindQuery;
